export type ScrollContext = {
  isInlineMode?: boolean;
  useContainerVirtualization?: boolean;
  windowListRef?: React.RefObject<{ scrollToTop: (smooth?: boolean) => void } | null>;
  containerListRef?: React.RefObject<{ scrollToTop: (smooth?: boolean) => void } | null>;
};

/**
 * Centralized scroll utility for gallery components
 * Handles different scroll scenarios with fallbacks
 */
export function scrollToTop(context: ScrollContext = {}) {
  const {
    isInlineMode,
    useContainerVirtualization,
    windowListRef,
    containerListRef,
  } = context;

  // Try container virtualization first if available
  if (useContainerVirtualization && containerListRef?.current) {
    containerListRef.current.scrollToTop(true);
    return;
  }

  // Try window virtualization if available
  if (windowListRef?.current) {
    windowListRef.current.scrollToTop(true);
    return;
  }

  // Fallback for inline/modal mode
  if (isInlineMode) {
    const modalContent = document.querySelector('[role="dialog"] .overflow-y-auto');
    if (modalContent) {
      modalContent.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
  }

  // Default fallback - scroll window
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

/**
 * Simple scroll to top for basic components
 */
export function simpleScrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

/**
 * Scroll with delay - useful after data updates
 */
export function delayedScrollToTop(context: ScrollContext = {}, delay = 100) {
  setTimeout(() => scrollToTop(context), delay);
}
